/* global $ */
import { get, throttle, bind, debounce }         from 'lodash';
import { isIpad, isMobile, isLocal,
         isElementScrolled, isElementInViewport,
         getRegion, capitalizeFirstLetter }      from 'utils/util';
import { Link }                                  from 'react-router';
import React, { PropTypes }                      from 'react';
import { connect }                               from 'reflux';
import TrackingActions                           from 'actions/tracking_actions';
import VideoActions                              from 'actions/video_actions';
import VideoStore                                from 'stores/video_store';
import DescriptorStore                           from 'stores/descriptor_store';
import StandalonePlayer                          from 'components/standalone_player';
import Chapters                                  from 'components/medscape_tv/chapters';
import TitleBar                                  from 'components/medscape_tv/title_bar';
import DescriptorActions                         from 'actions/descriptor_actions';
import Animation                                 from 'utils/animation';

export default React.createClass({
  displayName: 'Player.MedscapeTVTitleBar',
  propTypes: {
    descriptorJSON: PropTypes.object,
            params: PropTypes.object,
          location: PropTypes.object
  },
  mixins: [connect(VideoStore), connect(DescriptorStore)],
  getDefaultProps() {
    const region        = getRegion();
    if((region !== '' || region !== 'us') && region !== null)  {
      if(typeof window[`MedscapeTVInstance${capitalizeFirstLetter(region)}`] !== 'undefined') {
        window.MedscapeTVInstance = window[`MedscapeTVInstance${capitalizeFirstLetter(region)}`];
      }
    }
    return {
      descriptorJSON: window.MedscapeTVInstance
    };
  },
  getInitialState() {
    return {
      showMore: false,
      video: {
        isMouseIdle: false
      },
      descriptor: {
        chapters: []
      }
    };
  },
  componentDidMount() {
    DescriptorActions.loadJSON(window.MedscapeTVInstance, this.props.params.videoUrlFragment);
    this.scrollAnimationBreakPoint = 600;
    if(!isMobile() || isIpad()) {
      window.addEventListener('scroll', bind(debounce(this.scrollHandler, 10, {
        'leading': false,
        'trailing': true
      }), this));
      $('#tvPlayer').bind('transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd', (e) => {
        if(e.target.id === 'tvPlayer' && e.target.classList.contains('presistant-video-animation')) {
      const mountPoint    = document.querySelector('#tvPlayer'),
            restOfPage    = document.querySelector('.highlight-wrap');
          restOfPage.classList.remove('presistant-video-margin');
          mountPoint.classList.remove('presistant-video');
          this.scrollAnimationBreakPoint = $('.medscape-tv-chrome').offset().top;
        }
      });
    } else {
      window.addEventListener('scroll', bind(throttle(this.mobileScrollHandler, 50), this));
    }
  },
  componentWillReceiveProps(nextProps) {
    if(get(this, 'state.video.meta.videoUrlFragment', null) !== nextProps.params.videoUrlFragment) {
      TrackingActions.routeChange();
      const vidIndex = DescriptorStore.state.videos.findIndex((video) => video.videoUrlFragment === nextProps.params.videoUrlFragment);
      if(vidIndex !== -1) {
        VideoActions.selectVideo(DescriptorStore.state.videos[vidIndex], vidIndex);
      }
    }
    if(nextProps.params.videoUrlFragment !== this.props.params.videoUrlFragment) {
      if(!document.getElementById('medscape-tver').classList.contains('is-fullscreen') && !isMobile()) {
        document.getElementById('medscape-tver').style.opacity = 0;
        this.prevHeight = document.getElementById('medscape-tver').offsetHeight;
      }
    }
  },
  componentDidUpdate(prevProps) {
    if(prevProps.params.videoUrlFragment !== this.props.params.videoUrlFragment) {
      if(!document.getElementById('medscape-tver').classList.contains('is-fullscreen') && !isMobile()) {
        const wrapper = document.getElementById('medscape-tver');
          Animation.updateHeight(wrapper, wrapper.firstChild, this.prevHeight);
      }
    }
    if(this.scrollIds.length > 0 && this.firstRender === true) {
      this.firstRender = false;
      this.scrollIds = this.scrollIds.filter((id)=> {
        const isInVp = isElementScrolled(document.getElementById(id));
        if(isInVp) {
          TrackingActions.sectionScrollView(id);
        }
        return !isInVp;
      });
    }
  },
  getBreadCrumb() {
    return isLocal() ? `/`: `/mtv/${window.MedscapeTVInstance.seriesUrlFragment}/`;
  },
  firstRender: true,
  scrollIds: ['jsx-video-player', 'series-info', 'cast-list', 'info-graphic', 'more-med'],
  scrollHandler() {
    const pageFragment = get(this, 'props.routeParams.videoUrlFragment', '');
    if(pageFragment !== '') {
      const mountPoint    = document.querySelector('#tvPlayer'),
            restOfPage    = document.querySelector('.highlight-wrap');
      if(window.pageYOffset >= this.scrollAnimationBreakPoint && this.state.video.isPlaying === true && mountPoint.classList.contains('presistant-video-animation')) {
        this.scrollAnimationBreakPoint = $('.medscape-tv-chrome').offset().top;
        mountPoint.classList.add('presistant-video');
        restOfPage.classList.add('presistant-video-margin');
        mountPoint.classList.remove('presistant-video-animation');
      }
      if(window.pageYOffset < this.scrollAnimationBreakPoint && !mountPoint.classList.contains('presistant-video-animation')) {
        mountPoint.classList.add('presistant-video-animation');
      }
      const overlays = document.querySelectorAll('.overlay'),
            isOverlayVisible = Array.prototype.some.call(overlays, (el) => {
              return el.classList.contains('is-visible');
            });
      if(!isOverlayVisible) {
        const videoWrapElement = document.getElementById('video_player_screen');
          if(videoWrapElement !== null) {
          const     videoScrollOffset = (videoWrapElement.clientHeight / 1.33),
                       isVisible = isElementInViewport(videoWrapElement, videoScrollOffset),
                       isPlaying =  VideoStore.isPlaying();
          if(!get(this, 'state.video.isFullScreen', false)) {
            if(isVisible && !isPlaying && this.wasPlaying) {
              window.trackingEnabled = false;
              this.wasPlaying = false;
            } else if(!isVisible && isPlaying) {
              this.wasPlaying = true;
              window.trackingEnabled = false;
            }
          }
        }
      }
      if(this.scrollIds.length > 0) {
        this.scrollIds = this.scrollIds.filter((id)=> {
          const isInVp = isElementScrolled(document.getElementById(id));
          if(isInVp) {
            TrackingActions.sectionScrollView(id);
          }
          return !isInVp;
        });
      }
    }
  },
  mobileScrollHandler() {
    const pageFragment = get(this, 'props.routeParams.videoUrlFragment', '');
    if(pageFragment !== '') {
      const videoPlayerDiv = document.getElementById('medscape-tver'),
                clientRect = videoPlayerDiv.getBoundingClientRect(),
                mountPoint = document.getElementById('tvPlayer'),
              jsxVidPlayer = document.getElementById('jsx-video-player');
      if((clientRect.top + clientRect.height < clientRect.height/2) && this.state.video.isPlaying === true) {
        mountPoint.classList.add('presistant-video');
        jsxVidPlayer.classList.add('presistant-video-margin');
      }
      if(mountPoint.classList.contains('presistant-video') && window.scrollY < 250) {
        mountPoint.classList.remove('presistant-video');
        jsxVidPlayer.classList.remove('presistant-video-margin');
      }
    }
    if(this.scrollIds.length > 0) {
      this.scrollIds = this.scrollIds.filter((id)=> {
        const isInVp = isElementScrolled(document.getElementById(id));
        if(isInVp) {
          TrackingActions.sectionScrollView(id);
        }
        return !isInVp;
      });
    }
  },
  showMore() {
    TrackingActions.showMore();
    this.setState({
      showMore: true
    });
  },
  render: function() {
    let title, headerURL, viewed, titleBar, breadCrumb;
    const       chapters = this.state.descriptor.chapterList || [],
          hasMobileStyle = isMobile() && !isIpad(),
              currentVideo = chapters.find((video)=> {
                            if(typeof video.videoUrlFragment === 'undefined') {
                              return false;
                            } else {
                              return video.videoUrlFragment === this.props.params.videoUrlFragment;
                            }
                          }),
                videoIndex = chapters.indexOf(currentVideo);
    if(get(this, 'state.video.meta', false)) {
      headerURL = DescriptorStore.state.headerURL;
          title = this.state.video.meta.title;
         viewed = this.state.video.viewed;
    }
    let showMore = null;
    if(hasMobileStyle && !this.state.showMore) {
      showMore = (<div onClick={this.showMore} className="show-more">SHOW MORE
                    <div className="show-more-border">
                      <span className="down-arrow"></span>
                    </div>
                 </div>);
    }
    if(videoIndex !== -1) {
      titleBar = (<TitleBar
                    chapters={chapters}
                    index={videoIndex}
                  />);
      breadCrumb = (<Link className="back-link" to={this.getBreadCrumb()}>
                      <img src={ require('../../assets/images/video-player/carousel-left-arrow-hover.svg') } alt="LT" />
                      { window.MedscapeTVInstance.seriesTitle }
                    </Link>);
    }
    if(get(currentVideo, 'hasTitleCard', false) === true) {
        if(document.querySelector('.akamai-play')) {
          document.querySelector('.akamai-play').innerHTML = `<div class="episode-legend">Episode ${videoIndex+1}: ${chapters[videoIndex].title}</div>`;
        }
    }
    let mobilePresistantIfi = null;
    if(isMobile() && !isIpad() && (chapters[videoIndex]) && chapters[videoIndex].ifiHTML) {
      mobilePresistantIfi =  (<div className="ifiLinks-sticky" dangerouslySetInnerHTML={{ __html: chapters[videoIndex].ifiHTML }} />);
    }
    return (
        <div className="medscape-tv">
          { breadCrumb }
          <div className="medscape-tv-player"  id="tvPlayer" ref="tvPlayer">
            <div className="medscape-tv-poll-wrapper" id="pollWrapper" ref="pollWrapper">
              <StandalonePlayer
                className
                id="medscape-tver"
                videoIndex={videoIndex}
                descriptorJSON={ this.props.descriptorJSON }
                videoUrlFragment={ this.props.params.videoUrlFragment }
                isMouseIdle={this.state.video.isMouseIdle}
              />
              { titleBar }
            </div>
            { mobilePresistantIfi }
          </div>
          <Chapters
            ref="chaptersSlider"
            chapters={chapters}
            index={videoIndex}
            headerURL={headerURL}
            videoUrlFragmentUrl={this.props.location.pathname}
            title={title}
            hasMobileStyle={hasMobileStyle}
            showMore={true}
            viewed={viewed}
          />
          { showMore }
        </div>
    );
  }
});



/** WEBPACK FOOTER **
 ** ./modules/components/medscape_tv.jsx
 **/